(function () {
    'use strict';

    let filterObserver = null;
    let shadowRoot = null;
    let cachedProductCount = 0;

    function initFilterObserver() {
        const fastSimonApp = document.querySelector("#fast-simon-serp-app");

        if (!fastSimonApp) {
            console.warn('FastSimon app element not found');
            return;
        }

        shadowRoot = fastSimonApp.shadowRoot;

        if (!shadowRoot) {
            console.warn('Shadow root not found');
            return;
        }

        const serpPage = shadowRoot.querySelector('#fs-serp-page');

        if (!serpPage) {
            console.warn('SERP page container not found');
            return;
        }

        console.log('Initializing filter observer on:', serpPage);

        filterObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach(function (node) {
                        if (node.nodeType === 1 &&
                            (node.classList?.contains('filters-modal-wrapper') ||
                                node.querySelector?.('.filters-modal-wrapper'))) {

                            console.log('Filter container added to DOM:', node);
                            onFilterContainerAdded(node);
                        }
                    });
                }

                if (mutation.removedNodes.length > 0) {
                    mutation.removedNodes.forEach(function (node) {
                        if (node.nodeType === 1 &&
                            (node.classList?.contains('filters-modal-wrapper') ||
                                node.querySelector?.('.filters-modal-wrapper'))) {

                            console.log('Filter container removed from DOM:', node);
                            onFilterContainerRemoved(node);
                        }
                    });
                }
            });
        });

        filterObserver.observe(serpPage, {
            childList: true,
            subtree: true,
            attributes: false,
            characterData: false
        });

        console.log('Filter observer started successfully');

        checkExistingFilters(serpPage);
    }

    function checkExistingFilters(container) {
        const existingFilters = container.querySelector('.filters-modal-wrapper');
        if (existingFilters) {
            console.log('Existing filter container found:', existingFilters);
            onFilterContainerAdded(existingFilters);
        }
    }

    function addFilterBottomButtons(filtersModal) {
        if (filtersModal.querySelector('.fs-custom-filter-actions')) {
            console.log('Filter buttons already exist');
            return;
        }

        const getActiveFiltersCount = function () {
            const filtersContainer = filtersModal.querySelector('.filters-container');
            if (!filtersContainer) return 0;

            const checkedFilters = filtersContainer.querySelectorAll('input[type="checkbox"]:checked');
            return checkedFilters.length;
        };

        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'fs-custom-filter-actions';

        const clearButton = document.createElement('button');
        clearButton.className = 'fs-custom-clear-filters';
        clearButton.textContent = 'Clear Filters';
        clearButton.setAttribute('type', 'button');

        const showResultsButton = document.createElement('button');
        showResultsButton.className = 'fs-custom-show-results';
        showResultsButton.setAttribute('type', 'button');

        const updateResultsCount = function (productCount) {
            const count = getActiveFiltersCount();
            let totalResults = productCount !== undefined ? productCount : cachedProductCount;

            if (totalResults === 0 || totalResults === '0') {
                const resultsCountSelectors = [
                    '.fs-serp-results-count',
                    '.fs-results-count',
                    '[class*="results-count"]',
                    '[class*="product-count"]'
                ];

                for (const selector of resultsCountSelectors) {
                    const resultsText = shadowRoot.querySelector(selector);
                    if (resultsText) {
                        const match = resultsText.textContent.match(/\d+/);
                        if (match) {
                            totalResults = match[0];
                            cachedProductCount = parseInt(totalResults, 10);
                            break;
                        }
                    }
                }
            } else {
                if (productCount !== undefined) {
                    cachedProductCount = productCount;
                }
            }

            showResultsButton.innerHTML = `Show results <span class="fs-results-badge">(${totalResults})</span>`;
        };

        window._updateFilterResultsCount = updateResultsCount;

        updateResultsCount(cachedProductCount);

        clearButton.addEventListener('click', function () {
            console.log('Clear filters clicked');

            document.dispatchEvent(new CustomEvent('send-fast-simon-params', {
                detail: {
                    narrow: {}
                }
            }));

            console.log('FastSimon clear filter event dispatched');

            const filtersContainer = filtersModal.querySelector('.filters-container');
            if (filtersContainer) {
                const checkboxes = filtersContainer.querySelectorAll('input[type="checkbox"]:checked');
                checkboxes.forEach(function (checkbox) {
                    checkbox.checked = false;
                });

                const priceSlider = filtersContainer.querySelector('#price-range-slider');
                if (priceSlider) {
                    const minHandle = priceSlider.querySelector('[data-handle="0"]');
                    const maxHandle = priceSlider.querySelector('[data-handle="1"]');

                    if (minHandle && maxHandle) {
                        const resetEvent = new CustomEvent('reset');
                        priceSlider.dispatchEvent(resetEvent);
                    }
                }
            }

            setTimeout(() => {
                updateResultsCount();
            }, 100);
        });

        showResultsButton.addEventListener('click', function () {
            console.log('Show results clicked');

            const closeButton = filtersModal.querySelector('.fs-close-filters-button');
            if (closeButton) {
                closeButton.click();
            }
        });

        buttonContainer.appendChild(clearButton);
        buttonContainer.appendChild(showResultsButton);

        filtersModal.appendChild(buttonContainer);

        console.log('Filter bottom buttons added');

        const filtersContainer = filtersModal.querySelector('.filters-container');
        if (filtersContainer) {
            filtersContainer.addEventListener('change', function () {
                setTimeout(updateResultsCount, 100);
            });
        }

        return buttonContainer;
    }

    /**
     * Called when filter container is added
     */
    function onFilterContainerAdded(container) {
        console.log('Filter container opened');

        const isMobile = window.innerWidth <= 768;
        
        if (!isMobile) {
            console.log('Desktop view detected, skipping mobile customizations');
            return;
        }

        console.log('Mobile view detected, applying customizations');

        // Disable body scroll
        document.body.style.overflow = 'hidden';
        console.log('Background scroll disabled');

        const filtersModal = container.querySelector('.filters-modal');
        const filtersContainer = container.querySelector('.filters-container');

        if (filtersModal) {
            console.log('Filters modal element:', filtersModal);

            filtersModal.classList.add('fs-filters-active');

            const closeButton = filtersModal.querySelector('.fs-close-filters-button');
            if (closeButton) {
                closeButton.innerHTML = `
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.55212 7.82288L0 14.375L1.27075 15.6458L7.82288 9.09363L14.375 15.6458L15.6458 14.375L9.09363 7.82288L15.6458 1.27075L14.375 0L7.82288 6.55212L1.27075 0L0 1.27075L6.55212 7.82288Z" fill="#262626"/>
                    </svg>
                `;
                console.log('Close button icon replaced');
            }

            const title = filtersModal.querySelector('.fs-filters-title-text');

            if (title) {
                title.innerHTML = 'Filter by';
            }

            addFilterBottomButtons(filtersModal);
        }
    }

    function onFilterContainerRemoved(container) {
        console.log('Filter container closed');

        // Re-enable body scroll
        document.body.style.overflow = '';
        console.log('Background scroll re-enabled');

        if (filterChangeObserver) {
            filterChangeObserver.disconnect();
            filterChangeObserver = null;
        }
    }

    let filterChangeObserver = null;

    function disconnectObserver() {
        if (filterObserver) {
            filterObserver.disconnect();
            filterObserver = null;
            console.log('Filter observer disconnected');
        }
        if (filterChangeObserver) {
            filterChangeObserver.disconnect();
            filterChangeObserver = null;
        }
    }

    function initFilterChange() {
        console.log('Initializing FastSimon filter change observer');

        setTimeout(function () {
            initFilterObserver();
        }, 500);

        window.SerpOptions.registerHook("serp-top-page", ({ totalResults }) => {
            console.log('SERP top page hook - Total results:', totalResults);

            cachedProductCount = totalResults || 0;

            if (window._updateFilterResultsCount) {
                window._updateFilterResultsCount(totalResults);
            }
        });

        window.SerpOptions.registerHook("serp-product-list", ({ products, element }) => {
            const productCount = Object.keys(products).length;
            console.log('Product list hook - Total products:', productCount);

            cachedProductCount = productCount;

            if (window._updateFilterResultsCount) {
                window._updateFilterResultsCount(productCount);
            }
        });
    }

    window.disconnectFastSimonFilterObserver = disconnectObserver;

    if (window.SerpOptions) {
        initFilterChange();
    } else {
        window.addEventListener('fast-serp-ready', function () {
            initFilterChange();
        });
    }
})();